import { render, staticRenderFns } from "./PixelView.vue?vue&type=template&id=6b713fbb&"
import script from "./PixelView.vue?vue&type=script&lang=js&"
export * from "./PixelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports